<app-access-control [notForViewer]="true" [description]="true">
  <ng-container ngProjectAs="[slot][nonViewerContent]">
    <h4 [attr.data-test]="'title-purchaseActivityTitle'">{{ 'purchase-activity.title' | translate }}</h4>
    @if (isSparePartsEnabled && isCpqEnabled) {
      <div class="bare-list tabs__list">
        @for (tab of tabs; track tab) {
          <h6 class="tabs__item"
            [attr.data-test]="'tab-' + tab"
            [ngClass]="{'is-active is-active__bar': currentTab === tab}"
            (click)="changeTab(tab)">
            {{ 'purchase-activity.' + tab + '-tab-title' | translate }}
          </h6>
        }
      </div>
    }
    @if (isSparePartsEnabled && currentTab === EMultiCartTabs.PARTS) {
      <app-spare-part-purchase-activity
        (sparePartOrdersLoadedEmit)="sparePartOrdersLoaded = $event; trackPageReady()">
      </app-spare-part-purchase-activity>
    }
    @if (isCpqEnabled && currentTab === EMultiCartTabs.SERVICES) {
      <app-service-purchase-activity
        (loadServiceOrdersEmit)="serviceOrdersLoaded = $event; trackPageReady()">
      </app-service-purchase-activity>
    }
  </ng-container>
</app-access-control>
